import * as format from "@/utils/format"

const filters = Object.keys(format).filter(v=>v.startsWith('format'))
.reduce((a,key)=>{
  a[key.substring(6).toLowerCase()] = format[key]
  return a
},{})
export default {
  install(Vue) {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })
  }
}
